import React from "react";
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import Paper from "@material-ui/core/Paper";
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from "@material-ui/core/TableContainer";
import Box from "@material-ui/core/Box";

export default class ComponentToPrint extends React.Component {

    render() {
        const reportData = this.props.reportData;
        const searchData = this.props.searchData;

        return (
            <div className="pl-2 pr-2">
                <style>
                    {`
                        @media print {
                            .no-page-break {
                                page-break-after: avoid !important;
                                page-break-inside: avoid !important;
                            }
                            .keep-together {
                                page-break-inside: avoid !important;
                            }
                        }
                    `}
                </style>
                <h3><center><u>Duplicate Attendance Report</u></center></h3>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.groupName}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.estateName}</div>
                    <div className="col"><b>Collection Point: </b> {searchData.divisionName}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>

                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <div>
                                <Box display="flex" justifyContent="flex-end" p={2}>
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Date</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Reg No</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Employee Name</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Work Division</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Job</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Job Type</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Quantity</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Man Day</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {reportData.map((row, i) => (
                                                    <TableRow key={i}>
                                                        <TableCell align="center">{row.date}</TableCell>
                                                        <TableCell align="center">{row.registrationNumber}</TableCell>
                                                        <TableCell align="center">{row.employeeName}</TableCell>
                                                        <TableCell align="center">{row.workDivision}</TableCell>
                                                        <TableCell align="center">{row.job}</TableCell>
                                                        <TableCell align="center">{row.jobType}</TableCell>
                                                        <TableCell align="right">{parseFloat(row.quantity).toFixed(2)}</TableCell>
                                                        <TableCell align="center">{row.manDay}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}